export const RESOLUTION_IMAGE_UPLOAD = 300;
export const FORMAT_DATE_LANGUAGE = 'en';
export const FORMAT_DATE_DEFAULT = [
  { year: 'numeric' },
  { month: '2-digit' },
  { day: '2-digit' },
];
